import { ArrowUpRight } from "lucide-react";

const TONES = {
  default: "text-cyan-400",
  danger: "text-rose-400",
  warning: "text-amber-400",
  success: "text-emerald-400",
};

export function StatCard({ label, value, hint, icon: Icon, tone = "default", onClick, testid }) {
  return (
    <div
      onClick={onClick}
      data-testid={testid}
      className={`hw-card p-6 hw-rise ${onClick ? "cursor-pointer hover:border-cyan-500/40 transition-colors" : ""}`}
    >
      <div className="flex items-start justify-between">
        <span className="hw-eyebrow">{label}</span>
        {Icon && <Icon size={18} className={TONES[tone]} />}
      </div>
      <div className={`mt-3 font-head text-4xl font-extrabold tracking-tight ${tone === "default" ? "text-white" : TONES[tone]}`}>
        {value}
      </div>
      {hint && (
        <div className="mt-2 flex items-center gap-1 text-sm text-slate-400">
          {onClick && <ArrowUpRight size={14} className="text-cyan-500" />}
          {hint}
        </div>
      )}
    </div>
  );
}
